import { render } from "./FKAccordion.vue?vue&type=template&id=bf3ec56e&ts=true"
import script from "./FKAccordion.vue?vue&type=script&lang=ts"
export * from "./FKAccordion.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/FK/FKAccordion.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf3ec56e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf3ec56e', __exports__)) {
    api.reload('bf3ec56e', __exports__)
  }
  
  module.hot.accept("./FKAccordion.vue?vue&type=template&id=bf3ec56e&ts=true", () => {
    api.rerender('bf3ec56e', render)
  })

}


export default __exports__